import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ClickAwayListener from '@mui/material/ClickAwayListener';

const HelpDrawer = ({ closeDrawer, src }) => {

    const handleCloseDrawer = () => {
        closeDrawer();
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{height: "100%"}}>
            <ArgoAppBarHook
                title={"Help"}
                showMenuArrowButton="LEFT"
                onLeftIconButtonTouchTap={handleCloseDrawer}
                isDrawer={true}
                width={helpProps.width}
            />

            <ClickAwayListener onClickAway={handleCloseDrawer}>
                <Card expanded style={{paddingTop: "80px", height: "92%"}}>
                    <CardContent expandable style={{paddingTop: 0, paddingBottom: 0, height: "100%"}}>
                        {<iframe title="help" style={{width: "100%", height: "100%"}}
                                 src={src} frameBorder="0"/>}
                    </CardContent>
                </Card>
            </ClickAwayListener>
        </div>
    );
};

HelpDrawer.propTypes = {
    closeDrawer: PropTypes.func,
    src: PropTypes.string
};

const helpProps = {
    openSecondary: true,
    width: "60%",
    docked: false,
    anchor: "right"
};

export default HelpDrawer;
export {helpProps};

